import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Box } from '@mui/material'

interface SectionProps {
  children: React.ReactNode
  innerPadded?: boolean
  slideOnMobile?: boolean
  noVerticalPadding?: boolean
}

const Section = ({
  children,
  innerPadded,
  slideOnMobile,
  noVerticalPadding,
}: SectionProps) => {
  const { classes, cx } = useStyles()
  const content = innerPadded ? (
    <Box className={classes.innerPadded}>{children}</Box>
  ) : (
    children
  )
  return (
    <Box
      className={cx(classes.sectionPadding, {
        [classes.sectionMobileSlide]: slideOnMobile,
        [classes.noVerticalPadding]: noVerticalPadding,
      })}
    >
      {content}
    </Box>
  )
}

export default Section

const useStyles = makeStyles()((theme) => ({
  innerPadded: {
    [theme.breakpoints.up('tablet')]: {
      padding: '0 6%',
    },
  },
  sectionMobileSlide: {
    [theme.breakpoints.down('tablet')]: {
      padding: 0,
      paddingLeft: '6%',
      paddingRight: '6%',
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      '&::-webkit-scrollbar-thumb': {
        display: 'none',
      },
    },
  },
  noVerticalPadding: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  sectionPadding: {
    paddingLeft: '6%',
    paddingRight: '6%',
    paddingBottom: '4rem',
    paddingTop: '4rem',
    [theme.breakpoints.down('tablet')]: {
      paddingBottom: '6%',
      paddingTop: '6%',
    },
    '@media (min-width: 1456px)': {
      paddingLeft: 'calc((100% - 91rem)/2 + 5.5rem)',
      paddingRight: 'calc((100% - 91rem)/2 + 5.5rem)',
    },
  },
}))
